import type { FaireProductEntity } from "../../entity_types/product";

export const p_eryb7tcze3: FaireProductEntity = {
  token: "p_eryb7tcze3",
  type: "product",
  name: "Cartoon Ceramic Pet Food & Water Bowl_CWMM5932",
  brandToken: "b_g84ckd3mt5",
  brandName: "PAWPAWwholesale",
  imageUrl:
    "https://cdn.faire.com/fastly/a834fe2fda285979437bbd4a4dad5866f9a86050942cc44438d33124c45826a6.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1e5f478ba23a3ba0db0d04e11e1004029a5226c8cdca89aaa4d4d3570e5347f1.jpeg",
    "https://cdn.faire.com/fastly/79dd46aff0b0eb791b7b8692888988acfc0235b441893107fc01b41e5fa33f92.jpeg",
    "https://cdn.faire.com/fastly/2903e6923f3fa0b83311631132f9c419e012e8e61a473c3b537895d29535461b.jpeg",
    "https://cdn.faire.com/fastly/64131f58905dc8512ba57dca90bbec8a96263429779bb5de918d7ba7fd41ef1e.jpeg",
    "https://cdn.faire.com/fastly/5fcf0241ee88252a410cb9c60c93b0e032dd935c869e3f337b2e671697944103.jpeg",
    "https://cdn.faire.com/fastly/15f24795778511d07555454005a106676c130065efceded904811d296c834a62.jpeg",
    "https://cdn.faire.com/fastly/8c562f7dd417cd86ad3370eaff07ffc4c72254ac61e58cf5d68c3f24a8e99d0a.jpeg",
    "https://cdn.faire.com/fastly/842ad0282d4ff61bef7be2a8093e289e9321ba498c484d8f7a967afcf60a8d95.jpeg",
    "https://cdn.faire.com/fastly/94cddeb02ac8981413b92301bd8aa15336948be2577ed018a0b0858bccadf9c1.jpeg",
  ],
  priceDollars: 12.26,
  description:
    '-Product Type: Graffiti Straight-Rim Bowl\n-Material: 100%Ceramic\n-Dimensions:\nSmall Size: 12.8cm diameter × 5cm height / 5.0"×2.0" (400ml)\nLarge Size: 15.5cm diameter × 7cm height / 6.1"×2.8" (850ml)\n\nTypes of products that will be on the shelves during this period:\nPet bowl,Dog bowl,Cat bowl,Pet feeder,Food bowl,Water bowl,Drinking bowl,Food and water set,Non-slip base,Non-skid bottom,Elevated dog bowl,Raised pet feeder,Slow feeder bowl,Anti-choke design,Spill-proof, Splash-proof water bowl,Collapsible bowl,Travel dog bowl,Double bowl set,Dual bowl,Automatic pet feeder,Self-watering bowl,Gravity waterer,Stainless steel pet bowl,Ceramic dog bowl / Handmade ceramic bowl,BPA-free plastic bowl,Silicone collapsible bowl,Bamboo pet feeder,Wood stand,Eco-friendly,Sustainable materials,Minimalist pet bowl,Modern dog bowl,Cute cat bowl,Personalized pet bowl, Custom name bowl,Pastel color pet dish,Wooden stand pet bowl,Boho pet bowl,Small dog bowl / For puppies,Large dog bowl / For big dogs',
  tags: [],
  msrpDollars: 21.45,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:52.982Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
